module.exports = __webpack_public_path__ + "img/right.2bf7ebe5.svg";